var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loader)?_c('div',[_c('Loading')],1):_c('div',[(_vm.sede_id == 10)?_c('SedeCampusUniversitario',{attrs:{"municipio_id":_vm.municipio,"sede":"Campus Universitario"}}):_c('Principal',{attrs:{"municipio_id":_vm.municipio}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }